import z from 'zod';

import { DataLayerObjectSchema } from '../tracking.ts';

/**
 * Options shared by every form submit handler.
 *
 * Handler-specific option schemas extend this so that `formSubmitHandler()`
 * can always read `errorMessage` / `submitEvent` regardless of the handler.
 */
export const BaseOptionsSchema = z.object({
    errorMessage: z.string(),
    successMessage: z.string(),
    submitEvent: DataLayerObjectSchema.optional(),
});

export type BaseOptions = z.infer<typeof BaseOptionsSchema>;

/**
 * A form submit handler bundles the schemas used to validate the form data and
 * the handler options together with the function that performs the submit.
 *
 * `handle()` receives values that have already been parsed by these schemas.
 */
export interface FormSubmitHandler<
    Data = unknown,
    Options extends BaseOptions = BaseOptions,
> {
    dataSchema: z.ZodType<Data>;
    optionsSchema: z.ZodType<Options>;
    handle(data: Data, options: Options): Promise<string>;
}
